// extracted by mini-css-extract-plugin
export default {"loader":"TextLoad_loader__Lxor9","bblFadInOut":"TextLoad_bblFadInOut__SOpjT"};